import {
  Grid,
  GridItem,
  Heading,
  Img,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';

import { PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';

export const PaymentSection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const {
    title,
    subtitle,
    description,
    mastercardImageUrl,
    paypalImageUrl,
    giropayImageUrl,
    visaImageUrl,
  } = content.payment;

  return (
    <PageContainer bg="gray.50">
      <PageContent direction={['column', 'column', 'row']}>
        <Stack
          align="center"
          direction={['column', 'column', 'row']}
          spacing="2.25rem"
        >
          <VStack
            align="flex-start"
            spacing="5rem"
            maxW={['full', 'full', '50%']}
          >
            <VStack align="flex-start" spacing="1rem">
              <Heading fontSize="1.25rem" color="store.primary">
                {title}
              </Heading>

              <Heading fontSize="1.5rem">{subtitle}</Heading>

              <Text fontSize="1.125rem">{description}</Text>
            </VStack>
          </VStack>

          <Grid gridTemplateColumns="repeat(2, 1fr)" gap="2.25rem">
            <GridItem>
              <Img
                src={mastercardImageUrl}
                rounded="lg"
                shadow="xl"
                w="full"
                alt="Mastercard"
                loading="lazy"
              />
            </GridItem>

            <GridItem>
              <Img
                src={paypalImageUrl}
                rounded="lg"
                shadow="xl"
                w="full"
                alt="Mastercard"
                loading="lazy"
              />
            </GridItem>

            <GridItem>
              <Img
                src={giropayImageUrl}
                rounded="lg"
                shadow="xl"
                w="full"
                alt="Mastercard"
                loading="lazy"
              />
            </GridItem>

            <GridItem>
              <Img
                src={visaImageUrl}
                rounded="lg"
                shadow="xl"
                w="full"
                alt="Mastercard"
                loading="lazy"
              />
            </GridItem>
          </Grid>
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
